<template>
  <div class="bf-auth">
    <!-- Painel de marca -->
    <div class="bf-auth__brand">
      <div class="bf-auth__brand-inner">
        <img
          class="bf-auth__brand-logo"
          src="/img/brand/bindfy_logo_new_white.png"
          alt="Bindfy"
        />
        <h2>Recupere seu acesso.</h2>
        <p>
          Enviaremos um link para o seu e-mail com as instruções para redefinir
          sua senha com segurança.
        </p>
      </div>
      <div class="bf-auth__blob bf-auth__blob--1"></div>
      <div class="bf-auth__blob bf-auth__blob--2"></div>
    </div>

    <!-- Formulario -->
    <div class="bf-auth__form-wrap">
      <div class="bf-auth__card">
        <img
          class="bf-auth__logo-mobile"
          src="/img/brand/bindfy_logo_new_purple.png"
          alt="Bindfy"
        />
        <h1 class="bf-auth__title">Esqueci minha senha</h1>
        <p class="bf-auth__desc">
          Insira seu e-mail e enviaremos as instruções para recuperar sua senha
        </p>

        <form @submit.prevent="handleSubmit()">
          <div class="bf-field">
            <label>E-mail</label>
            <TextInput
              :label="'Digite o seu e-mail'"
              :type="'email'"
              v-model="forgotPasswordForm.login"
              :error-messages="
                v$.login.$errors ? v$.login.$errors[0]?.$message : undefined
              "
            />
          </div>

          <PrimaryButton
            :is-loading="isLoading"
            label="Enviar e-mail de recuperação"
          />

          <div class="bf-auth__signup">
            <router-link to="/autenticar/acessar" class="bf-link">
              ← Voltar para login
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { useRouter } from "vue-router";

import { useVuelidate } from "@vuelidate/core";

import { useAuth } from "@/composables/useAuth";

import PrimaryButton from "@/components/Forms/BasicElements/Button/PrimaryButton.vue";

import TextInput from "@/components/Forms/BasicElements/Input/TextInput.vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    TextInput,
    PrimaryButton,
  },
  setup() {
    const router = useRouter();

    const {
      forgotPasswordFormRules,
      forgotPasswordForm,
      forgotPassword,
      isLoading,
    } = useAuth();

    const handleSubmit = async () => {
      try {
        const result = await v$.value.$validate();

        if (!result) return;

        const response = await forgotPassword(forgotPasswordForm);

        if (response) {
          router.push({ name: "SignInPage" });
        }
      } catch (e) {
        console.error(e);
      }
    };

    const v$ = useVuelidate(forgotPasswordFormRules, forgotPasswordForm);

    return {
      forgotPasswordForm,
      isLoading,
      handleSubmit,
      v$,
    };
  },
});
</script>
